import React from "react";
import "./styles.scss";

const LOGO = require("../../assets/icons/nalu/Light.svg");

const OPAQUE = {
  NO: "",
  YES: "opaque"
};

const COMPRESS = {
  NO: "",
  YES: "compressed"
};

export default class NavigationBar extends React.Component {
  state = { isScrolled: false, isCompressed: true };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    this.setState({
      isScrolled: window.scrollY > 20
    });
  };

  className = props => {
    let className = "nav-bar nav-bar-container";
    className += " " + (props.isScrolled || false ? OPAQUE.YES : OPAQUE.NO);
    className +=
      " " + (props.isCompressed || true ? COMPRESS.YES : COMPRESS.NO);
    return className;
  };

  render() {
    return (
      <div className={this.className(this.state)}>
        <img
          className="centered"
          src={LOGO}
          onClick={this.props.onIconClicked}
          alt="app icon"
        />
      </div>
    );
  }
}
